import _ from 'lodash';

import CloseTeamAssistPanel from 'actions/team_assist/close_team_assist_panel';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';
import OpenTeamAssistPanel from 'actions/team_assist/open_team_assist_panel';
import { SidePanelType } from 'models/side_panel';

export default class ToggleTeamAssistPanel {
  constructor(context) {
    this.context = context;
  }

  run(attrs) {
    const currentLocation = this.context.stores.currentLocation.get();
    if (!currentLocation.customerId) {
      return;
    }

    if (!attrs) {
      const composition = getCompositionsStore(this.context).findBy({ id: currentLocation.currentCompositionId });
      attrs = {
        compositionId: _.get(composition, 'id'),
        conversationId: _.get(composition, 'conversationId'),
        customerId: _.get(composition, 'customerId'),
      };
    }

    if (this.context.stores.sidePanel.get().isShowing(SidePanelType.AI_ASSIST)) {
      this.context.executeAction(CloseTeamAssistPanel, attrs);
    } else {
      this.context.executeAction(OpenTeamAssistPanel, attrs);
    }
  }
}
